module.exports = __webpack_public_path__ + "static/vib_play0s-7d35fca862b06bf997531addc0a45279.jpg";